/** Applique un fond de zone texte (vide ou « transparent » → transparent). */
export function resolveTextBackgroundColor(backgroundColor) {
  const raw = typeof backgroundColor === 'string' ? backgroundColor.trim() : '';
  if (!raw || raw === 'transparent') return 'transparent';
  return raw;
}

export function withTextBackgroundStyle(style, backgroundColor) {
  return {
    ...(style || {}),
    backgroundColor: resolveTextBackgroundColor(backgroundColor),
  };
}
